/* Workshop booking: date picker and time slots (requests only, no availability). */
(function () {
  var root = document.querySelector('[data-frb-booking-picker]');
  if (!root) return;

  var dateInput = root.querySelector('[data-frb-date]');
  var dateText = root.querySelector('[data-frb-date-text]');
  var timeSelect = root.querySelector('[data-frb-time]');
  var dateError = root.querySelector('[data-frb-date-error]');
  var timeError = root.querySelector('[data-frb-time-error]');
  var data = root.dataset;
  var form = dateInput.form;
  var dateName = dateInput.name;
  var weekdays = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];

  // The date input keeps its name without JS. With JS the hidden field carries
  // a readable Danish date so the email reads "Ønsket dato: torsdag 15. oktober 2026".
  dateText.name = dateName;
  dateInput.removeAttribute('name');

  function parse(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  }

  function toMinutes(hhmm) {
    var p = String(hhmm || '').split(':');
    return Number(p[0]) * 60 + Number(p[1] || 0);
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function dateProblem() {
    var value = dateInput.value;
    if (!value) return '';
    var d = parse(value);
    if (!d) return data.errorRange;
    if (value < dateInput.min || value > dateInput.max) return data.errorRange;
    if (d.getDay() === 0) return data.errorSunday;
    return '';
  }

  function buildTimes() {
    var current = timeSelect.value;
    var d = dateProblem() ? null : parse(dateInput.value);
    timeSelect.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    if (!d) {
      first.textContent = data.timeFirst;
      timeSelect.appendChild(first);
      timeSelect.disabled = true;
      return;
    }
    first.textContent = data.timePlaceholder;
    timeSelect.appendChild(first);
    var saturday = d.getDay() === 6;
    var start = toMinutes(saturday ? data.saturdayOpen : data.weekdayOpen);
    var end = toMinutes(saturday ? data.saturdayLast : data.weekdayLast);
    for (var m = start; m <= end; m += 30) {
      var label = pad(Math.floor(m / 60)) + ':' + pad(m % 60);
      var opt = document.createElement('option');
      opt.value = label;
      opt.textContent = label;
      if (label === current) opt.selected = true;
      timeSelect.appendChild(opt);
    }
    timeSelect.disabled = false;
  }

  function show(el, input, message) {
    el.textContent = message;
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  function syncDate() {
    var problem = dateProblem();
    var d = parse(dateInput.value);
    show(dateError, dateInput, problem);
    dateText.value = d && !problem
      ? weekdays[d.getDay()] + ' ' + d.getDate() + '. ' + months[d.getMonth()] + ' ' + d.getFullYear()
      : '';
    show(timeError, timeSelect, '');
    buildTimes();
  }

  dateInput.addEventListener('change', syncDate);
  dateInput.addEventListener('input', syncDate);
  timeSelect.addEventListener('change', function () {
    show(timeError, timeSelect, '');
  });

  form.addEventListener('submit', function (event) {
    var problem = dateProblem();
    show(dateError, dateInput, problem);
    var needsTime = !problem && dateInput.value && !timeSelect.value;
    show(timeError, timeSelect, needsTime ? data.errorTime : '');
    if (problem) {
      event.preventDefault();
      dateInput.focus();
    } else if (needsTime) {
      event.preventDefault();
      timeSelect.focus();
    }
  });

  syncDate();
})();
